import React, { useMemo } from "react";
import { colors } from "theme";

const SpiralCompletion = ({
  relevant_employees = 0,
  total_employees = 0,
  sub_text = "Employee Data Received",
  width = "100%",
}) => {
  const isEmpty = useMemo(() => {
    if (relevant_employees === 0 && total_employees === 0) return true;
    return false;
  }, [relevant_employees, total_employees]);

  let percentage = (relevant_employees / total_employees) * 100;

  if (isEmpty) {
    percentage = 0;
  }
  const radius = 30;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <svg viewBox="0 0 100 100" style={{ width }}>
      <circle
        cx={50}
        cy={50}
        r={radius}
        stroke="#D9D9D9"
        fill="transparent"
        strokeWidth={4}
        strokeDasharray={circumference}
        strokeDashoffset={0}
      />
      <circle
        cx={50}
        cy={50}
        r={radius}
        stroke={colors.accentColor}
        fill="transparent"
        strokeWidth={7}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform="rotate(-90 50 50)"
      />
      <text
        style={{ fill: "#4a4a4a" }}
        x="50%"
        y="45%"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="Inter"
      >
        <tspan fontSize={8} fontWeight={900}>
          {isEmpty ? "0" : `${relevant_employees}/${total_employees}`}
        </tspan>
        <tspan fontSize={3} x="50%" dy="4em">
          {sub_text}
        </tspan>
      </text>
    </svg>
  );
};

export default SpiralCompletion;
